import axios from "axios";
import { getBackendUrl } from "../config";

// URL base da API configurada via variável de ambiente
const baseURL = getBackendUrl();

// Instância principal da API utilizada nas chamadas autenticadas
const api = axios.create({
	baseURL,
	withCredentials: true,
});

// Instância aberta (openApi) para chamadas que não requerem autenticação, mas ainda podem precisar do token
export const openApi = axios.create({
	baseURL,
});

// Função auxiliar para obter o token armazenado no localStorage
const getAuthToken = () => {
	const token = localStorage.getItem("token");
	if (token && token !== "undefined" && token !== "null") {
		try {
			return JSON.parse(token);
		} catch (e) {
			console.error("Erro ao fazer parse do token", e);
			localStorage.removeItem("token");
		}
	}
	return null;
};

// Interceptor de requisição: adiciona header Authorization se token existir
const requestInterceptor = (config) => {
	const token = getAuthToken();
	if (token) {
		config.headers["Authorization"] = `Bearer ${token}`;
	}
	return config;
};

// Registrar interceptadores nas duas instâncias
api.interceptors.request.use(requestInterceptor);

// 402 = empresa bloqueada por atraso na assinatura (decidido pelo backend).
// Avisa o BillingGate, que mostra a tela de bloqueio.
api.interceptors.response.use(
	(response) => response,
	(error) => {
		if (error?.response?.status === 402) {
			window.dispatchEvent(new CustomEvent("billing:blocked", { detail: error.response.data }));
		}
		return Promise.reject(error);
	}
);

openApi.interceptors.request.use(requestInterceptor);

// Exporta a instância padrão
export default api;
